import React from 'react';
export function Footer() {
  return <footer className="border-t border-white/10 py-12 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-214">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-215">
        <div className="text-center md:text-left" data-id="element-216">
          <a href="#" className="text-2xl font-bold tracking-tight block mb-2" style={{
          fontFamily: "'Space Grotesk', sans-serif"
        }} data-id="element-217">
            <span className="text-white" data-id="element-218">ai</span>
            <span className="text-[#c9a84c]" data-id="element-219">.</span>
            <span className="text-white" data-id="element-220">web</span>
          </a>
          <p className="text-white/40 text-sm" data-id="element-221">
            © 2025 aiwebsitepackage.com. All rights reserved.
          </p>
        </div>

        <div className="flex space-x-6 text-sm text-white/40" data-id="element-222">
          <a href="/privacy" onClick={e => {
          e.preventDefault();
          window.history.pushState({}, '', '/privacy');
          window.dispatchEvent(new PopStateEvent('popstate'));
          window.scrollTo(0, 0);
        }} className="hover:text-[#c9a84c] transition-colors" data-id="element-223">
            Privacy Policy
          </a>
          <a href="/terms" onClick={e => {
          e.preventDefault();
          window.history.pushState({}, '', '/terms');
          window.dispatchEvent(new PopStateEvent('popstate'));
          window.scrollTo(0, 0);
        }} className="hover:text-[#c9a84c] transition-colors" data-id="element-224">
            Terms of Service
          </a>
        </div>

        <div className="text-center md:text-right" data-id="element-225">
          <p className="text-white/40 text-sm flex items-center gap-1" data-id="element-226">
            Made with <span className="text-red-500" data-id="element-227">♥</span> for Dublin
            businesses
          </p>
        </div>
      </div>
    </footer>;
}